import { Failure } from '@geekbears/gb-ngrx-stack-base';
import {
  GetAllUsersResponse,
  GetUserDetailsResponse,
} from '@modules/company-manager/users/domain';
import {
  GetAllRequestResponse,
  GetSingleRequestResponse,
} from '@modules/regular-user/requests/domain';
import { createAction, props } from '@ngrx/store';
import {
  Approve,
  GetApprovalsCountResponse,
  GetApprovesResponse,
} from '../../domain/entities/approves.entity';
import { ApiQueryParams } from '@utils/api-query-params.type';
/**
 * Actions For All Approves
 */
export const getAllApprovesAction = createAction(
  '[Approves] Get All Approves Action',
  props<{
    companyId: string;
  }>()
);
export const getAllApprovesSuccessAction = createAction(
  '[Approves] Get All Approves Success Action',
  props<{
    response: GetApprovesResponse;
  }>()
);
export const getAllApprovesFailureAction = createAction(
  '[Approves] Get All Approves Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Export Approves
 */
export const exportApprovesAction = createAction(
  '[Approves] Export Approves Action',
  props<{
    approves: any[];
  }>()
);
export const exportApprovesSuccessAction = createAction(
  '[Approves] Export Approves Success Action',
  props<{
    response: any;
  }>()
);
export const exportApprovesFailureAction = createAction(
  '[Approves] Export Approves Failure Action',
  props<{
    failure: Failure;
  }>()
);

/**
 * Actions For Request By Id
 */
export const getRequestByIdAction = createAction(
  '[Approves] Get Request By Id Action',
  props<{
    requestId: string;
  }>()
);
export const getRequestByIdSuccessAction = createAction(
  '[Approves] Get Request By Id Success Action',
  props<{
    response: GetSingleRequestResponse;
  }>()
);
export const getRequestByIdFailureAction = createAction(
  '[Approves] Get Request By Id Failure Action',
  props<{
    failure: Failure;
  }>()
);

/**
 * Actions For Approve A Request
 */
export const approveARequestAction = createAction(
  '[Approves] Approve A Request Action',
  props<{
    requestId: string;
    message: string;
  }>()
);
export const approveARequestSuccessAction = createAction(
  '[Approves] Approve A Request Success Action',
  props<{
    requestId: string;
    response: GetSingleRequestResponse;
  }>()
);
export const approveARequestFailureAction = createAction(
  '[Approves] Approve A Request Failure Action',
  props<{
    requestId: string;
    failure: Failure;
  }>()
);

/**
 * Actions For Approve A Request
 */
export const denyARequestAction = createAction(
  '[Approves] Change Status Action',
  props<{
    requestId: string;
    message: string;
  }>()
);
export const denyARequestSuccessAction = createAction(
  '[Approves] Change Status Success Action',
  props<{
    requestId: string;
    response: GetSingleRequestResponse;
  }>()
);
export const denyARequestFailureAction = createAction(
  '[Approves] Change Status Failure Action',
  props<{
    requestId: string;
    failure: Failure;
  }>()
);

/**
 * Actions For Get All Approvers
 */
export const getApproversAction = createAction(
  '[Approves] Get All Approvers Action'
);
export const getApproversSuccessAction = createAction(
  '[Approves] Get All Approvers Success Action',
  props<{
    response: GetAllUsersResponse;
  }>()
);
export const getApproversFailureAction = createAction(
  '[Approves] Get All Approvers Failure Action',
  props<{
    failure: Failure;
  }>()
);

/**
 * Actions For Get My Approves
 */
export const getMyApprovesAction = createAction(
  '[Approves] Get My Approves Action',
  props<ApiQueryParams>()
);
export const getMyApprovesSuccessAction = createAction(
  '[Approves] Get My Approves Success Action',
  props<{
    response: GetAllRequestResponse;
  }>()
);
export const getMyApprovesFailureAction = createAction(
  '[Approves] Get My Approves Failure Action',
  props<{
    failure: Failure;
  }>()
);

/**
 * Actions For Get My Approvals Count
 */
export const approvalsCountAction = createAction(
  '[Approves] Get My Approvals Count Action',
  props<ApiQueryParams>()
  // props<{
  //   userId: string;
  // }>()
);
export const approvalsCountSuccessAction = createAction(
  '[Approves] Get My Approvals Count Success Action',
  props<{
    response: GetApprovalsCountResponse;
  }>()
);
export const approvalsCountFailureAction = createAction(
  '[Approves] Get My Approvals Count Failure Action',
  props<{
    failure: Failure;
  }>()
);

/**
 * Actions For Get My Approvals Count
 */
export const pendingApprovalsAction = createAction(
  '[Approves] Get Pending Approvals Action',
  props<ApiQueryParams>()
  // props<{
  //   userId: string;
  // }>()
);
export const pendingApprovalsSuccessAction = createAction(
  '[Approves] Get Pending Approvals Success Action',
  props<{
    response: GetApprovesResponse;
  }>()
);
export const pendingApprovalsFailureAction = createAction(
  '[Approves] Get Pending Approvals Failure Action',
  props<{
    failure: Failure;
  }>()
);

/**
 * Actions For Get Approvers By Company
 */
export const getApproversByCompanyAction = createAction(
  '[Approves] Get Approvers By Company Action',
  props<{
    companyId: string;
  }>()
);
export const getApproversByCompanySuccessAction = createAction(
  '[Approves] Get Approvers By Company Success Action',
  props<{
    response: GetApprovesResponse;
  }>()
);
export const getApproversByCompanyFailureAction = createAction(
  '[Approves] Get Approvers By Company Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Get Approvers By Company
 */
export const getNextPendingRequestAction = createAction(
  '[Approves] Get Next Pending Request Action',
  props<{
    companyId: string;
  }>()
);
export const getNextPendingRequestSuccessAction = createAction(
  '[Approves] Get Next Pending Request Success Action',
  props<{
    response: GetApprovesResponse;
  }>()
);
export const getNextPendingRequestFailureAction = createAction(
  '[Approves] Get Next Pending Request Failure Action',
  props<{
    failure: Failure;
  }>()
);

/**
 * This actions dispatch the fetch to get all the pending approval and count pending approvals
 */
export const pendingApprovalsDataAction = createAction(
  '[Approves] Get Pending Approvals Data Action',
  props<ApiQueryParams>()
);
/**
 * This actions dispatch the fetch to get all the pending approval and count pending approvals
 */
export const historyParamsAction = createAction(
  '[Approves]  History Params Action',
  props<ApiQueryParams>()
);

export const ApprovesActions = {
  /**
   * Actions For Get All Approves
   */
  getAllApproves: getAllApprovesAction,
  getAllApprovesSuccess: getAllApprovesSuccessAction,
  getAllApprovesFailure: getAllApprovesFailureAction,

  /**
   * Actions For Export Approves
   */
  exportApproves: exportApprovesAction,
  exportApprovesSuccess: exportApprovesSuccessAction,
  exportApprovesFailure: exportApprovesFailureAction,

  /**
   * Actions For Approve By Id
   */
  getRequestById: getRequestByIdAction,
  getRequestByIdSuccess: getRequestByIdSuccessAction,
  getRequestByIdFailure: getRequestByIdFailureAction,

  /**
   * Actions For Approve A Request
   */
  approveARequest: approveARequestAction,
  approveARequestSuccess: approveARequestSuccessAction,
  approveARequestFailure: approveARequestFailureAction,

  /**
   * Actions For Deny A Request
   */
  denyARequest: denyARequestAction,
  denyARequestSuccess: denyARequestSuccessAction,
  denyARequestFailure: denyARequestFailureAction,

  /**
   * Actions For Get My Approves
   */
  myApproves: getMyApprovesAction,
  myApprovesSuccess: getMyApprovesSuccessAction,
  myApprovesFailure: getMyApprovesFailureAction,

  /**
   * Actions For Get My Approvals Count
   */
  approvalsCount: approvalsCountAction,
  approvalsCountSuccess: approvalsCountSuccessAction,
  approvalsCountFailure: approvalsCountFailureAction,

  /**
   * Actions For Get Pending Approvals Count
   */
  pendingApprovals: pendingApprovalsAction,
  pendingApprovalsSuccess: pendingApprovalsSuccessAction,
  pendingApprovalsFailure: pendingApprovalsFailureAction,

  /**
   * Actions For Get Approvers By Company
   */
  getApproversByCompany: getApproversByCompanyAction,
  getApproversByCompanySuccess: getApproversByCompanySuccessAction,
  getApproversByCompanyFailure: getApproversByCompanyFailureAction,

  /**
   * Pending approvals
   */
  pendingApprovalsData: pendingApprovalsDataAction,
  /**
   * History Params
   */
  historyParamsAction: historyParamsAction,
};
